import { render, staticRenderFns } from "./CMChips.vue?vue&type=template&id=49b96526&scoped=true&lang=pug"
import script from "./CMChips.vue?vue&type=script&lang=js"
export * from "./CMChips.vue?vue&type=script&lang=js"
import style0 from "./CMChips.vue?vue&type=style&index=0&id=49b96526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b96526",
  null
  
)

export default component.exports